import { Controller } from "@hotwired/stimulus";

/** GO4S DS — zone de dépôt de fichier (clic + glisser-déposer). */
export default class extends Controller {
  static targets = ["input", "title"];

  browse() {
    // Garde anti-réentrance : le clic programmatique sur l'input remonte au
    // conteneur et rappellerait browse() (double ouverture du sélecteur).
    if (this._opening) return;
    this._opening = true;
    if (this.hasInputTarget) this.inputTarget.click();
    setTimeout(() => { this._opening = false; }, 0);
  }

  over(e) { e.preventDefault(); this.element.classList.add("is-drag"); }
  leave() { this.element.classList.remove("is-drag"); }

  drop(e) {
    e.preventDefault();
    this.element.classList.remove("is-drag");
    if (this.hasInputTarget && e.dataTransfer.files.length) {
      this.inputTarget.files = e.dataTransfer.files;
      this.picked();
    }
  }

  // Affiche le nom du fichier sélectionné (ou le nombre de fichiers) dans le
  // titre de la zone.
  picked() {
    if (!this.hasInputTarget || !this.hasTitleTarget) return;
    const files = this.inputTarget.files;
    if (!files || !files.length) return;
    if (this._defaultTitle === undefined) this._defaultTitle = this.titleTarget.textContent;
    this.titleTarget.textContent =
      files.length > 1 ? `${files.length} fichiers sélectionnés` : files[0].name;
    this.element.classList.add("is-filled");
  }
}
